<div class="routine-check shadow-l rounded-2 mb-3 d-flex <%= isChecked ? 'checked' : '' %>"
     data-type="routine-selection">
  <div class="align-self-center" style="min-width: 40px">
    <% if ( icon ) {  %>
      <img src="/assets/icons/routines/<%= icon %>" style="max-width: 18px; margin-left: 11px; margin-bottom: 4px;" />
    <% }  %>
  </div>
  <div class="align-self-center routine-name">
    <%= name %>
  </div>
  <div class="ms-auto ps-3 align-self-center text-center" style="min-width: 50px!important;">
    <i class="far fa-square"></i>
    <i class="far fa-square-check"></i>
  </div>
</div>
